import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import crmModule from "@kubdee/module-crm";

export default createModuleLayout({
  moduleId: MODULES.CRM,
  moduleConfig: crmModule,
  sidebarInsetClassName: "flex flex-col h-svh min-w-0 overflow-hidden",
});
